import {Component, Output, EventEmitter, Input, AfterViewInit, OnInit, OnChanges, SimpleChanges} from '@angular/core';
import {CalendarService} from "../calendar.service";
import {CalEvent} from "../utils/model/CalEvent";
import {DateUtils} from "../utils/common/DateUtils";
import {CalendarMode} from "../model/calendar-mode";

@Component({
    selector: 'calendar-widget-today',
    templateUrl: './calendar-today.component.html',
    styleUrls: ['./calendar-today.component.scss']
})
export class CalendarTodayComponent  implements  OnInit,OnChanges {
    @Output() onChange = new EventEmitter<any>();
    @Output() listEvent = new EventEmitter<any>();
    @Input()  eventsList : any[] = [];
    events: CalEvent[] | any = [];
    listEventGroup: any[] = [];
    colors = [
        // '#438EB9',
        '#007bff',
        '#3CA54A',
        '#FF9800',
        '#EF5B49',
        '#77901B',
        '#dc3545',
        '#808080'
    ];

    private _date: Date = new Date();

    constructor(private calendarService: CalendarService) {
        // this.calendarService.ready(() => this.loadTodayEvents());
    }
    ngOnInit(): void {
    }
    ngOnChanges(changes: SimpleChanges): void {
      this.listEventGroup =  this.convert(this.eventsList);
      console.log(this.listEventGroup);
    }
    convert(eventsList : any[]){
      let results:any[] = [];
      let arr = eventsList.reduce((r, a)=> {
        let day = new Date(a.start_date);
        let dategroup = day.getFullYear()+'-'+(day.getMonth()+1)+'-'+day.getDate();
        a['dategroup'] = dategroup;
        r[a['dategroup']] = r[a['dategroup']] || [];
        r[a['dategroup']].push(a);
        return r;
      }, Object.create(null));
      Object.keys(arr).forEach(key=>{
        results.push({dategroup: key, items: arr[key]});
      });
      return results;
    }


  loadTodayEvents() {
        if (!this._date) {
            return;
        }
        this.calendarService.loadEvents({
            day: DateUtils.dayOfYear(this._date),
            year: this._date.getFullYear()
        }, (events: any[]) => {
            events.forEach((e: any) => this._initEventStatus(e));
            this.events = events;
            this.listEvent.emit(this.events);

            // this.events = events.slice(0, 3); // Maximum 3 events
        });
    }
    loadEvents(mode: any, date: any) {
        this.calendarService.loadEvents(this.getParams(mode,date), (events: any[]) => {
            events.forEach((e: any) => this._initEventStatus(e));
            this.events = events;
            this.listEvent.emit(this.events)
        });
    }

    getParams(mode: any, date: any){
        let params = {};
        if(mode === CalendarMode.timeGridWeek){
            let weekRange = DateUtils.getWeekRange(date);
            // console.log('params',weekRange,this.getRangeParams(weekRange.startWeek, weekRange.endWeek))
            params= {
                from: DateUtils.dayOfYear(weekRange.startWeek),
                to: DateUtils.dayOfYear(weekRange.endWeek),
                year: date.getFullYear(),
            }

        }
        if(mode === CalendarMode.dayGridMonth){
            let from: any, to: any;
            date.setDate(1);
            from = DateUtils.getDateStartWeek(date);
            date.setMonth(date.getMonth() + 1);
            date.setTime(date.getTime() - 1);
            to = DateUtils.getDateEndWeek(date);
            params = {
                from: from.getDayOfYear(),
                to: to.getDayOfYear(),
                year: date.getFullYear(),
            }
        }
        if(mode === CalendarMode.timeGridDay){
            params = {
                day: date.getDayOfYear(),
                year: date.getFullYear(),
            }
        }
        // console.log('params',params)
        return params;
    }
       onViewEvent(event: CalEvent, jsEvent: MouseEvent, targetEl: HTMLElement) {
        // this.calendarService.viewEvent(event, jsEvent, targetEl, () => {
        //     this.loadTodayEvents();
        //     this.onChange.emit(true);
        // });
        this.events.forEach((ele: any)=>{
            if(ele.uuid !== event.uuid){
                ele.active =  false;}
        });
        event.active =  true;
        this.calendarService.changeEventCalender(event.uuid);
    }

    private _initEventStatus(event: any) {
        let now = new Date();

        event.progressing = event.start < now && event.end > now;
        event.ended = event.end < now;
        event.pending = event.start > now;

        if (event.progressing) {
            event.statusText = 'Đang diễn ra';
            event.statusColor = this.colors[0];
        } else if (event.pending) {
            event.statusText = 'Chưa diễn ra';
            event.statusColor = this.colors[5];
        } else {
            event.statusText = 'Kết thúc';
            event.statusColor = this.colors[6];
        }

        event.style = {
            'background-color': this.colors[event.mode]
        };
    }
}
